import { StringParam, useQueryParam } from 'use-query-params'

import { Toasts } from '@fourthwall/components'

import type { AnalyticsReportDefinition } from '../../../types'
import { useGoogleAnalyticsConfigurationQuery } from '../queries/useGoogleAnalyticsConfigurationQuery'
import { useGoogleAnalyticsConnection } from './useGoogleAnalyticsConnection'

export const useGoogleAnalytics = () => {
  const { connectLink, disconnect } = useGoogleAnalyticsConnection()
  const [connectedParam, setConnectedParam] = useQueryParam('connected', StringParam)
  const isConnectedStatus = typeof connectedParam === 'string'

  const { googleAnalyticsConfigurationQuery } = useGoogleAnalyticsConfigurationQuery(undefined, {
    refetchInterval: (data) =>
      isConnectedStatus && data?.type && ['NOT_CONNECTED', 'IN_PROGRESS'].includes(data.type)
        ? 2_000
        : false,
  })

  const handleDisconnect = () => {
    setConnectedParam(undefined)

    disconnect(() => {
      Toasts.notify('Disconnected from Google Analytics successfully.', { type: 'success' })
    })
  }

  const isLoading =
    !googleAnalyticsConfigurationQuery.data || googleAnalyticsConfigurationQuery.isInitialLoading

  const reportUris =
    googleAnalyticsConfigurationQuery.data &&
    googleAnalyticsConfigurationQuery.data.type === 'CONNECTED'
      ? googleAnalyticsConfigurationQuery.data.reportUris
      : undefined

  const reportLinks: Record<Partial<AnalyticsReportDefinition['id']>, string> | undefined =
    reportUris
      ? {
          conversion_rates: reportUris.purchaseJourneyUri,
          visitors: reportUris.reportsSnapshotUri,
          sales_by_source: reportUris.trafficAcquisitionUri,
          sessions_by_source: reportUris.trafficAcquisitionUri,
        }
      : undefined

  return {
    data: googleAnalyticsConfigurationQuery.data,
    isLoading,
    connectLink,
    reportLinks,
    onDisconnect: handleDisconnect,
  }
}
